// extracted by mini-css-extract-plugin
module.exports =  {"title":"qx5zcJ","defaultWeight":"LvdclS"};